import { Box, Typography } from "@mui/material";
import moment from "moment";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

moment.locale("de");

export const AskomaTitle = () => {
  const { isMobile, referenceDate } = useAppContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "row" : "column",
        alignItems: isMobile ? "flex-end" : "flex-start",
        justifyContent: isMobile ? "flex-start" : "unset",
        gap: isMobile ? 0 : 0,
        whiteSpace: "nowrap",
      }}
    >
      {/* ✅ Desktop only */}
      {!isMobile && (
        <Typography variant="h6" color="primary">
          Askoma Monitor
        </Typography>
      )}

      {/* ✅ Subtitle */}
      <Typography
        color="primary"
        variant={isMobile ? "h6" : "h4"}
        fontWeight="bold"
      >
        {moment(referenceDate).format(isMobile ? "dd, DD.MM." : "dd, DD. MMMM")}
      </Typography>
    </Box>
  );
};
